import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import StorefrontIcon from "@mui/icons-material/Storefront";
import { Link, useNavigate } from "react-router-dom";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { Badge } from "@mui/material";
import { useSelector } from "react-redux";

const pages = [
  "Home",
  "Electronics",
  "Jewelery",
  "Men's Clothing",
  "Women's Clothing",
];
const settings = ["Profile", "Account", "Dashboard", "Logout"];

function Navbar() {
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const navigate = useNavigate();
  const { basket } = useSelector((state) => state.basket);
  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  return (
    <>
      <AppBar
        position="static"
        sx={{ backgroundColor: "#10A3AE", top: "10px", height: "15vh" }}
      >
        <Container maxWidth="xl" sx={{height:"100%"}}>
          <Toolbar disableGutters sx={{mt:3}}>
            <StorefrontIcon
              sx={{ display: { xs: "none", md: "flex" }, mr: 1,color:"black", fontSize:"2rem" }}
            />
            <Typography
              variant="h6"
              noWrap
              fontSize={25}
              component={Link}
              to="/home"
              sx={{
                mr: 2,
                display: { xs: "none", md: "flex" },
                fontFamily: "monospace",
                fontWeight: 700,
                letterSpacing: ".2rem",
                color: "brown",
                textDecoration: "none",
                textShadow:"1px 2px 1px black"
              }}
            >
              YOUR SHOP
            </Typography>

            <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
                color="inherit"
              >
                <MenuIcon />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorElNav}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
                sx={{
                  display: { xs: "block", md: "none" },
                }}
              >
                {pages.map((page) => (
                  <MenuItem key={page} onClick={handleCloseNavMenu}>
                    <Typography component={Link}
                  to={`/${page}`} textAlign="center" sx={{ textDecoration: "none", 
                  color: "black",}}>{page}</Typography>
                  </MenuItem>
                ))}
              </Menu>
            </Box>
            <StorefrontIcon
              sx={{ display: { xs: "flex", md: "none" }, mr: 1 }}
            />
            <Typography
              variant="h5"
              noWrap
              component={Link}
              to="/home"
              sx={{
                mr: 2,
                display: { xs: "flex", md: "none" },
                flexGrow: 1,
                fontFamily: "monospace",
                fontWeight: 700,
                color: "brown",
                textDecoration: "none",
              }}
            >
              DENİZ SHOP
            </Typography>
            <Box pt={4} sx={{ flexGrow: 1, display: { xs: "none", md: "flex" }, alignItems:"end", justifyContent:"space-evenly" }}>
              {pages.map((page) => (
                <Button
                  component={Link}
                  to={`/${page}`}
                  key={page}
                  onClick={handleCloseNavMenu}
                  sx={{mt:2, color: "white", display: "block",fontSize:"1.4rem",":hover":{color:"brown"} }}
                >
                  {page}
                </Button>
              ))}
            </Box>
            <IconButton aria-label="cart">
                <Badge
                  badgeContent={basket.length}
                  color="error"
                  overlap="circular"
                >
                  <ShoppingCartIcon
                    style={{ color: "white" }}
                    onClick={() => navigate("/basket")}
                  />
                </Badge>
              </IconButton>
            {/* <Box display={"flex"} gap={3} sx={{ flexGrow: 0 }}>
              
              <Tooltip title="Open settings">
                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                  <Avatar alt="Remy Sharp" src="/static/images/avatar/2.jpg" />
                </IconButton>
              </Tooltip>
              <Menu
                sx={{ mt: "45px" }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
              >
                {settings.map((setting) => (
                  <MenuItem key={setting} onClick={handleCloseUserMenu}>
                    <Typography textAlign="center">{setting}</Typography>
                  </MenuItem>
                ))}
              </Menu>
            </Box> */}
          </Toolbar>
        </Container>
      </AppBar>

      <Box height="7vh"></Box>
    </>
  );
}
export default Navbar;
